import TopSection, { SOURCE_LIST } from './TopSection';

export default TopSection;
export { SOURCE_LIST };
